import { User } from '../domain';
import { UserJson } from '../types';

export const mapUser = (user: UserJson): User => ({
  id: user.id ?? 0,
  firstName: user.firstName ?? '',
  lastName: user.lastName ?? '',
  email: user.email ?? '',
  fullName: `${user.firstName} ${user.lastName}`,
  organizations:
    user.organizations?.map((org) => ({
      id: org.id ?? 0,
      name: org.name ?? '',
    })) ?? [],
});

export const mapUsers = (users: UserJson[]): User[] => users.map(mapUser);
